module.exports = __webpack_public_path__ + "img/zhys_zhTc.e56b7130.png";